import { Dispatch, SetStateAction } from 'react';
import { CarIncludeModal } from './car-include-modal';
import { CarIncludeBottomSheet } from './car-includes-bottomsheet';
import { CarDetailsType } from '@/types';
import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import { gradientColors } from '../../constants';

export const CarIncludesContent = ({
    open,
    setOpen,
    IS_DESKTOP,
    showCarDetailsHeader = false,
    selectedCar,
    carType,
}: {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    IS_DESKTOP: boolean;
    showCarDetailsHeader?: boolean;
    selectedCar: CarDetailsType;
    carType: CarTypesEnum;
}) => {
    const gradientColor = gradientColors(carType);
    return (
        <>
            {IS_DESKTOP ? (
                <CarIncludeModal
                    openModal={open}
                    setOpenModal={setOpen}
                    showCarDetailsHeader={showCarDetailsHeader}
                    selectedCar={selectedCar}
                    carType={carType}
                    gradientColor={gradientColor}
                />
            ) : (
                <CarIncludeBottomSheet
                    showCarDetailsHeader={showCarDetailsHeader}
                    openBottomSheet={open}
                    setOpenBottomSheet={setOpen}
                    selectedCar={selectedCar}
                    carType={carType}
                    gradientColor={gradientColor}
                />
            )}
        </>
    );
};
